var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0326 2.44884C21.3003 1.76415 20.3464 1.41583 19.396 1.40633L13.4258 1.34668L13.4815 6.58967L20.398 6.65877C22.6045 6.68082 23.7004 4.00801 22.0326 2.44884Z",
    fill: "#FFCE71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32268 1.18302C6.36412 1.17349 5.42475 1.50258 4.70671 2.17297C4.04113 2.79439 3.6343 3.6577 3.64454 4.61616L6.47482 19.2556C6.48505 20.214 6.07829 21.0773 5.41264 21.6988C4.69455 22.3692 3.75523 22.6982 2.79662 22.6887L16.6646 22.8266C17.6231 22.8361 18.5625 22.507 19.2805 21.8366C19.9461 21.2152 20.353 20.3518 20.3427 19.3934C20.34 19.1408 17.5139 4.89357 17.5124 4.75402C17.5022 3.79556 17.4695 2.92788 18.1351 2.30646C18.8532 1.63607 19.353 1.30261 20.3116 1.31214L7.32268 1.18302Z",
    fill: "#FFEECB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9972 21.5949C12.0373 20.6313 12.0142 19.2541 12.5958 18.268C12.908 17.7388 12.5175 17.0469 11.8881 17.0469H3.60856C1.39899 17.0469 0.273042 19.9349 1.92669 21.5949C2.6528 22.3238 3.60448 22.6884 4.55621 22.6884H15.6268C14.6751 22.6884 13.7234 22.3238 12.9972 21.5949Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0786 11.6874L10.1349 11.7466C9.66561 11.7609 9.29669 12.1549 9.31091 12.6266C9.32513 13.0982 9.71711 13.4691 10.1864 13.4548L12.1301 13.3955C12.5994 13.3813 12.9683 12.9873 12.9541 12.5156C12.9399 12.0439 12.5479 11.6731 12.0786 11.6874Z",
    fill: "#373737",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46361 7.71056L12.5403 7.61662C13.0096 7.60229 13.3785 7.20827 13.3643 6.73658C13.3501 6.2649 12.9582 5.89411 12.4889 5.90844L9.41222 6.00238C8.94295 6.0167 8.574 6.41073 8.58819 6.88241C8.60238 7.3541 8.99428 7.72489 9.46361 7.71056Z",
    fill: "#373737",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1336 8.78108L8.92394 8.9096C8.45467 8.92393 8.08572 9.31795 8.09991 9.78964C8.1141 10.2613 8.50606 10.6321 8.97533 10.6178L13.185 10.4893C13.6543 10.4749 14.0232 10.0809 14.009 9.60923C13.9948 9.13754 13.6029 8.76675 13.1336 8.78108Z",
    fill: "#373737",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4464 19.5225L16.8029 17.0215H15.8862H14.9695L14.326 19.5225C14.2578 19.7877 14.4569 20.0463 14.7294 20.0463C14.8117 20.0463 14.8922 20.0218 14.9606 19.9759L15.8862 19.3557L16.8118 19.9759C16.8802 20.0218 16.9606 20.0463 17.0429 20.0463C17.3154 20.0462 17.5146 19.7877 17.4464 19.5225Z",
    fill: "#EA5B70"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9397 17.5587C17.121 17.5587 18.0787 16.5961 18.0787 15.4087C18.0787 14.2213 17.121 13.2588 15.9397 13.2588C14.7584 13.2588 13.8008 14.2213 13.8008 15.4087C13.8008 16.5961 14.7584 17.5587 15.9397 17.5587Z",
    fill: "#FFB357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.d1f19e3596d31289934f7c28c7a6b0dd.svg";
export { ForwardRef as ReactComponent };